<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">

      <slide>
        <div class="padding">
          <p>I waited for Oska on the plusten near the school gates. He came running out clutching a giant crayon he must have taken from art class.</p>
<br>
          <p>As we were walking home he dragged the crayon along walls. I looked at the marks he was leaving, but his weren't the first ones there. His lines crossed and interweaved with others.</p>
<br>
          <p>I started wondering who left those marks, whether they were also unintentionally writing the city, or were they trying to say 'i was here'.</p>
<br>
          <p>I started picking out out every mark, every piece of fumbled graffiti, every mark in wet concrete, and the continuous blur of the city slowly became a textured history in front of me.</p>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'Marks'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
